import { apiRequest } from './index';

const API_URL = '/apply/contact-info/';

type PerlBoolean = 0 | 1;

/* eslint-disable camelcase */
export interface ApplyEvent {
  already_applied: PerlBoolean;
  first_apply: PerlBoolean;
  first_apply_source: string;
  is_mau: PerlBoolean;
  is_responder: PerlBoolean;
  last_mau: PerlBoolean | '';
  new_response_contact_id: string;
  new_response_lvk: string;
  new_response_quiz_id: string;
  new_response_source: string;
  prior_mau: PerlBoolean | '';
  response_id: string;
  transaction_id: string;
}

interface ResponseData extends ApplyEvent {
  encrypted_response_id: string;
  interview: PerlBoolean;
  post_apply_flow: PerlBoolean;
  show_modal: PerlBoolean;
  success: PerlBoolean;
}
/* eslint-enable camelcase */

interface CreateResponseParams {
  applyMethod: string,
  encQuizId: string,
  lvk: string,
  placementId: string,
  encPlacementId: string,
}

/**
 * Endpoint that applies the contact to the quiz
 * @param {string} data.applyMethod
 * @param {string} data.encQuizId
 * @param {string} data.lvk
 * @param {string} data.placementId
 * @param {object} options
 * @returns json response
 */
export async function createResponse({
  applyMethod = 'fe.zr-utilities.api.createResponse',
  encQuizId,
  lvk,
  placementId,
  encPlacementId,
}: CreateResponseParams, options?: Record<string, unknown>): Promise<ResponseData> {
  const ualData = {
    placement_id: placementId,
    enc_placement_id: encPlacementId,
    lvk,
  };
  const fetchInit = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      apply_method: applyMethod,
      ual_data: ualData,
    }),
    ...options,
  };

  const endpoint = API_URL + encQuizId;

  const response = await apiRequest(endpoint, fetchInit);
  const responseJson = await response.json() as ResponseData;
  return responseJson;
}

export default createResponse;
